<section class="login-section">
    <div class="login-wrapper">
        <div class="logo">
            <a href="javascript:void(0)">
                <img [style.width]="companyName !== 'Crizac Ltd' ? '60%' : ''" [src]="brandLogo" alt="Crizac" title="Crizac" />
            </a>
            <h2>Employee Portal</h2>
        </div>
        <h3>Authenticator code required</h3>
        <p>Enter the six-digit code in your authenticator app to continue.</p>
        <div class="qr-code-wrapper text-center">
            <img *ngIf="qrCode" [src]="qrCode" alt="QR Code" />
        </div>
        <form [formGroup]="securityForm" (ngSubmit)="submitCode()" class="login-form">
            <!-- Verification Code -->
            <label>Verification Code</label>
            <div class="v-code-group" (copy)="onCopy($event)">
                <ng-container *ngFor="let box of boxes; index as i">
                    <mat-form-field appearance="fill" class="full-width">
                        <input 
                            matInput 
                            maxlength="6" 
                            #digitInput 
                            [id]="'code-' + i" 
                            (input)="onInput($event, i)"
                            (keydown)="onKeyDown($event, i)" 
                            [value]="codeArray[i]" 
                            autocomplete="off" 
                            (paste)="onPaste($event)"
                            [class.selected-text]="isAllSelected" />
                    </mat-form-field>
                </ng-container>
            </div>

            <!-- Login Button with Dynamic Styling -->
            <button 
              class="full-width" 
              mat-raised-button 
              type="submit"
              [disabled]="!isFormValid"
              [style.background-color]="(!isFormValid ? buttonDisabledBgColor : buttonBgColor) + ' !important'"
              [style.color]="(!isFormValid ? buttonDisabledTextColor : buttonTextColor) + ' !important'">
              Login
            </button>
            
            <p class="txt-copyright text-center">© {{currentYear}} {{companyName}}. All rights reserved.</p>
        </form>
    </div>
</section>